// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.selector_HBKFc {
  display : flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}
.selectorHint_RdXxC {
  font-size:9px;
  font-weight: normal;
  position: absolute;
  top:0;
  left:0;
  z-index:10;
  color:rgba(0,0,0,1.0);
}

.selectorButton_bFL4c:focus {
  background:transparent;
}

.updaterSelector_Th0fh div {
  display: flex;
  width:100%;
}

.selectorButton_bFL4c {
  background : transparent;
  border : none;
  box-shadow: none;
  border-radius: 0;
  padding-left:0px;
  padding-right:0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  cursor: pointer;
}

.selectorButtonTitle_hSIdB {
  display : flex;
  justify-content: space-between;
  align-items: center;
  text-shadow: none;
  padding: 5px 5px 5px 0;
  font-weight: bolder;
  font-size:13px;
}

.selectorButtonTitle_hSIdB .hint_Qwouh {
  color :#999999;
}

.selectorButtonTitle_hSIdB i {
  color: #6A6BE1;
}
`, "",{"version":3,"sources":["webpack://./src/editors/interpolators/style.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,KAAK;EACL,MAAM;EACN,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["\n.selector {\n  display : flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n}\n.selectorHint {\n  font-size:9px;\n  font-weight: normal;\n  position: absolute;\n  top:0;\n  left:0;\n  z-index:10;\n  color:rgba(0,0,0,1.0);\n}\n\n.selectorButton:focus {\n  background:transparent;\n}\n\n.updaterSelector div {\n  display: flex;\n  width:100%;\n}\n\n.selectorButton {\n  background : transparent;\n  border : none;\n  box-shadow: none;\n  border-radius: 0;\n  padding-left:0px;\n  padding-right:0px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 1;\n  cursor: pointer;\n}\n\n.selectorButtonTitle {\n  display : flex;\n  justify-content: space-between;\n  align-items: center;\n  text-shadow: none;\n  padding: 5px 5px 5px 0;\n  font-weight: bolder;\n  font-size:13px;\n}\n\n.selectorButtonTitle .hint {\n  color :#999999;\n}\n\n.selectorButtonTitle i {\n  color: #6A6BE1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selector": `selector_HBKFc`,
	"selectorHint": `selectorHint_RdXxC`,
	"selectorButton": `selectorButton_bFL4c`,
	"updaterSelector": `updaterSelector_Th0fh`,
	"selectorButtonTitle": `selectorButtonTitle_hSIdB`,
	"hint": `hint_Qwouh`
};
export default ___CSS_LOADER_EXPORT___;
